import src from "IMAGE";
export default { src, width: 630, height: 630, blurWidth: 0, blurHeight: 0};
